import ENVIRONMENT from '@/env';

/* eslint-disable */
/* global hj */
/**
 * The tracking ID for your Hotjar property.
 */
const TRACKING_ID = ENVIRONMENT.tracking;

/**
 * Initializes all the analytics setup. Creates trackers and sets initial
 * values on the trackers.
 */
export const init = () => {
  const url = '//static.hotjar.com/c/hotjar-';
  const query = '.js?sv=';

  window.hj = window.hj || function() {
    (window.hj.q = window.hj.q || []).push(arguments);
  }

  window._hjSettings = {
    hjid: TRACKING_ID,
    hjsv: 5
  };

  const head = document.getElementsByTagName('head')[0];
  const element = document.createElement('script');
  element.async = 1;
  element.src = url + window._hjSettings.hjid + query + window._hjSettings.hjsv;

  head.appendChild(element);
};



// WEBPACK FOOTER //
// src/utils/tracking.js